import { popupMessagesHandler } from "../redux/Orders/OrderActionCreators";
import Store from "../redux/Store";

export const ssn_validator = (ssn, legal = false) => {
  if (legal) {
    var L = ssn.length;
    if (L < 11 || parseInt(ssn, 10) === 0) return false;
    if (parseInt(ssn.substr(3, 6), 10) === 0) return false;
    var c = parseInt(ssn.substr(10, 1), 10);
    var d = parseInt(ssn.substr(9, 1), 10) + 2;
    // eslint-disable-next-line
    var z = new Array(29, 27, 23, 19, 17);
    var s = 0;
    for (var i = 0; i < 10; i++)
      s += (d + parseInt(ssn.substr(i, 1), 10)) * z[i % 5];
    s = s % 11;
    if (s === 10) s = 0;
    return c === s;
  } else {
    if (
      !/^\d{10}$/.test(ssn) ||
      ssn === "0000000000" ||
      ssn === "1111111111" ||
      ssn === "2222222222" ||
      ssn === "3333333333" ||
      ssn === "4444444444" ||
      ssn === "5555555555" ||
      ssn === "6666666666" ||
      ssn === "7777777777" ||
      ssn === "8888888888" ||
      ssn === "9999999999"
    )
      return false;
    var check = parseInt(ssn[9]);
    var sum = 0;
    // eslint-disable-next-line
    var i;
    for (i = 0; i < 9; ++i) sum += parseInt(ssn[i]) * (10 - i);
    sum %= 11;
    return (sum < 2 && check === sum) || (sum >= 2 && check + sum === 11);
  }
};

export const just_persian = (str) => {
  var p = /^[\u0600-\u06FF\s]+$/;
  if (!p.test(str)) {
    return false;
  }
  return true;
};

export const valid_Persian_email = (event, field) => {
  const charCodeList = [
    33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51,
    52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70,
    71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89,
    90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106,
    107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121,
    122, 123, 124, 125, 126,
  ];

  const numbers = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];

  const is_number = numbers.indexOf(event.which);
  const alert_text = (e, message) => {
    const { popupMessages } = Store.getState().OrderReducer;
    const { mode } = popupMessages;

    e.preventDefault();
    Store.dispatch(
      popupMessagesHandler({
        mode: !mode ? true : false,
        message: message,
        color: "warning",
      })
    );
  };

  const check = charCodeList.indexOf(event.which);
  if (field.name === "addressDetails") {
    if (check === -1 || is_number > -1) {
      return true;
    } else {
      return alert_text(event, "زبان کیبورد خود را به فارسی تغییر دهید");
    }
  } else if (
    field.name === "username" ||
    field.name === "password" ||
    field.name === "confirm_password" ||
    field.name === "old_password" ||
    field.name === "email"
  ) {
    if (check > -1) {
      return true;
    } else {
      return alert_text(event, "زبان کیبورد خود را به انگلیسی تغییر دهید");
    }
  } else if (
    field.name === "first_name" ||
    field.name === "last_name" ||
    // field.name === "addressDetails" ||
    field.name === "board_title"
  ) {
    if (check === -1) {
      return true;
    } else {
      return alert_text(event, "زبان کیبورد خود را فارسی تغییر دهید");
    }
  } else if (field.name === "temp_token" || field.name === "cellphone") {
    if (is_number > -1) {
      return true;
    } else {
      alert_text(event, "مقادیر را به صورت عدد وارد کنید");
    }
  } else if (field.name === "ssn" || field.name === "pocode") {
    if (is_number > -1 && event.target.value.length + 1 < 11) {
      return true;
    } else if (is_number !== -1) {
      alert_text(event, "حداکثر تعداد کاراکتر 10 رقم است");
    } else {
      alert_text(event, "مقادیر را به صورت عدد وارد کنید");
    }
  } else if (field.name === "phone" || field.name === "office_number") {
    if (is_number > -1 && event.target.value.length + 1 < 12) {
      return true;
    } else if (is_number !== -1) {
      alert_text(event, "حداکثر تعداد کاراکتر 11 رقم است");
    } else {
      alert_text(event, "مقادیر را به صورت عدد وارد کنید");
    }
  }
};
export const Strong_Password =
  "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})";

// -------------------------------------------------------------------------------------------------------- utils

export const utils = {
  today: (date) => {
    date = date ? date : new Date();
    let t = date
      .toLocaleDateString("fa-IR")
      .replace(/([۰-۹])/g, (token) =>
        String.fromCharCode(token.charCodeAt(0) - 1728)
      );
    t = t.split("/");
    t = `${t[0]}/${t[1] < 10 ? "0" : ""}${t[1]}/${t[2] < 10 ? "0" : ""}${t[2]}`;
    return t;
  },
  get_time: (date) => {
    let st = date ? new Date(date) : new Date();
    return `${st.getHours() < 10 ? "0" : ""}${st.getHours()}:${
      st.getMinutes() < 10 ? "0" : ""
    }${st.getMinutes()}:${st.getSeconds() < 10 ? "0" : ""}${st.getSeconds()}`;
  },
  now: (nd) => {
    nd = nd ? new Date(nd) : new Date();
    let h = nd.getHours();
    let m = nd.getMinutes();
    return `${h < 10 ? "0" : ""}${h}:${m < 10 ? "0" : ""}${m}`;
  },
};
